import { Navigate } from 'react-router';

import {
  MainContainer,
  RootContainer,
} from '@/backoffice/app/routes/root/root.styled';
import { BackofficeSidebar } from '@/backoffice/features/backoffice-sidebar/backoffice-sidebar';
import { RouteErrorContent } from '@/shared/features/error/components/route-error-content/route-error-content';
import { Header } from '@/shared/features/header/header';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

// Backoffice's own error shell — deliberately does NOT render Console's
// AuthenticatedRoute (which would surface console/tenant-user modals like
// "This company is inactive" / accept-privacy-policy on Backoffice).
export const BackofficeErrorBoundaryRoute = () => {
  const user = useAppSelector(selectUser);

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <RootContainer>
      <BackofficeSidebar />
      <MainContainer>
        <Header
          hideAlerts
          hideNotifications
          hideTrialExpiredBadge
          hideBreadcrumbs
        />
        <RouteErrorContent />
      </MainContainer>
    </RootContainer>
  );
};
